<template>
    <painel titulo="Solicitação - Filtros" icone="pi pi-calendar" :mostrarRefresh="false" v-show="mostrarListagem">
        <filtros @pesquisar="pesquisar($event)" @limpar="limpar()"></filtros>
    </painel>
    <painel titulo="Licitação - Solicitações" icone="pi pi-gavel" :refreshFunction="atualizar" v-show="mostrarListagem">
        <tabela
            :ordenador="true"
            :data="solicitacoes"
            dataKey="solicitacaoId"
            :globalFilterFields="[
                'numeroProcesso',
                'gestor',
                'unidade',
                'responsavel',
                'dataCadastro',
                'tipoDemandaDescr',
                'descricaoEtapa',
                'objetoSolicitacao',
            ]"
            stateKey="dt-licitacoes-solicitacoes"
        >
            <template #botoes>
                <btn-inserir v-if="$temAcessoView('LICITACOES-01')"></btn-inserir>
            </template>
            <template #conteudo>
                <Column style="min-width: 10px; max-width: 10px">
                    <template #body="slotProps">
                        <btn-detalhar v-if="$temAcessoView('LICITACOES-02')" :solicitacao="slotProps.data"></btn-detalhar>
                    </template>
                </Column>
                <Column style="min-width: 60px; max-width: 60px" field="numeroProcesso" header="Nº Processo" :sortable="true">
                    <template #body="slotProps">
                        {{ slotProps.data.numeroProcesso }}
                    </template>
                </Column>
                <Column style="min-width: 100px; max-width: 100px" field="gestor" header="Gestor" :sortable="true">
                    <template #body="slotProps">
                        {{ slotProps.data.gestor ?? 'tt' }}
                    </template>
                </Column>
                <Column style="min-width: 50px; max-width: 50px" field="unidade" header="Unidade" :sortable="true">
                    <template #body="slotProps">
                        {{ slotProps.data.unidade }}
                    </template>
                </Column>
                <Column style="min-width: 100px; max-width: 100px" field="responsavel" header="Responsável" :sortable="true">
                    <template #body="slotProps">
                        {{ slotProps.data.responsavel }}
                    </template>
                </Column>
                <Column style="min-width: 70px; max-width: 70px" field="dataCadastro" header="Data Solicitação" :sortable="true">
                    <template #body="slotProps">
                        {{ $dateFormat(slotProps.data.dataCadastro, 'DD/MM/YYYY') }}
                    </template>
                </Column>
                <Column style="min-width: 50px; max-width: 100px" field="descricaoEtapa" header=" Etapa atual" :sortable="true">
                    <template #body="slotProps">
                        <status :status="slotProps.data.descricaoProximaEtapa" style="text-transform: uppercase"></status>
                    </template>
                </Column>
                <Column style="min-width: 50px; max-width: 100px" field="objetoSolicitacao" header="Objeto do TR" :sortable="true">
                    <template #body="slotProps">
                        {{ slotProps.data.objetoSolicitacao == 'null' ? ' ' : slotProps.data.objetoSolicitacao }}
                    </template>
                </Column>
            </template>
        </tabela>
    </painel>
</template>

<script>
import Service from '../services';
import Filtros from './Filtros.vue';
import BtnDetalhar from '../detalhamento/BtnDetalhar.vue';
import BtnInserir from './BtnInserir.vue';
export default {
    components: {
        BtnDetalhar,
        BtnInserir,
        Filtros,
    },

    data() {
        return {
            solicitacoes: null,
            Filtros: null,
        };
    },

    computed: {
        mostrarListagem() {
            return this.$route.name == 'Licitacoes_Solicitacoes';
        },
    },

    methods: {
        pesquisar(filtros) {
            this.obterSolicitacoes(filtros);
        },
        obterSolicitacoes(filtros = '') {
            this.$store.dispatch('addRequest');
            Service.obterTodasSolicitacoes(filtros).then((response) => {
                if (response && response.success) {
                    this.solicitacoes = response.data;
                } else {
                    this.solicitacoes = null;
                }
                this.$store.dispatch('removeRequest');
            });
        },

        atualizar() {
            this.obterSolicitacoes();
        },
    },
};
</script>
